import { Input, type InputProps } from "@/components/ui/input";
import { sanitizePercentInput } from "@/lib/pricing";

export interface PercentInputProps extends Omit<InputProps, "onChange" | "type" | "inputMode"> {
  onChange: (value: string) => void;
}

export function PercentInput({ value, onChange, ...props }: PercentInputProps) {
  return (
    <Input
      {...props}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={value}
      onChange={(event) => onChange(sanitizePercentInput(event.target.value))}
    />
  );
}
